import React from 'react';
import Button from "../../UI/Button";
import Row from "../../UI/Row";
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";
import {usePurchase} from "../../../utilities/context/purchase/purchase-context";

const Addon = ({addon, onClick}) => {

    const {subscription} = useDashboard();
    const {addAddon, removeAddon, selectedAddons} = usePurchase();

    const handleClick = async () => {
        isSelected() ? removeFromCart() : addToCart();
    }

    const isSelected = () => {
        return selectedAddons.some(_addon => _addon.id === addon.id);
    }

    const addToCart = () => {
        addAddon(addon);
    }

    const removeFromCart = () => {
        removeAddon(addon);
    }

    return (
        <div className={`flex flex-col md:flex-row text-left md:items-center border p-2 mb-4 ${isSelected() ? "border-ea_yellow border-4" : ""}`}>
            <div className="flex-1">
                <div className="font-bold">{addon.name}</div>
                <div className="italic text-sm">{addon.description}</div>
                <div>Prezzo giornaliero <span className="font-medium">{parseFloat(addon.costs.daily_cost).toFixed(4)}€</span> per il numero di giorni rimanenti del tuo abbonamento: {subscription.missing_days}</div>
                <Row className="gap-1 items-center">
                    <div>Prezzo totale: </div>
                    <div className="font-medium text-ea_yellow text-xl">{parseFloat(addon.costs.suscribing_cost).toFixed(2)}€</div>
                    <div className="text-xs">(IVA inclusa)</div>
                </Row>
            </div>

            <div className="text-black flex flex-row justify-center mt-2 md:mt-0">
                <Button onClick={handleClick}>{isSelected() ? "Rimuovi" : "Aggiungi"}</Button>
            </div>
        </div>
    );
};

export default Addon;